import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllListUsers } from "../../../redux/booking/action";
import React, { useState, useEffect } from "react";
import swal from "sweetalert";

export default function FilterModel({ modal, setModal, params, setParams }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const users = useSelector((state) => state.bookingSlice?.getUsersList);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  console.log(selectedData, "selectedData");
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // If the startdate is selected, make sure the enddate is not earlier
    if (name === "startdate" && params.enddate && value > params.enddate) {
      swal({
        text: "Start date cannot be greater than End date.",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
      return;
    }

    // If the enddate is selected, make sure the startdate is not later
    if (name === "enddate" && params.startdate && value < params.startdate) {
      swal({
        text: "End date cannot be earlier than Start date.",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
      return;
    }

    // Set the selected date in the state
    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
      page: 1,
    }));
  };

  const [paramss, setParamss] = useState({
    page: 1,
  });

  useEffect(() => {
    dispatch(getAllListUsers(paramss));
  }, [dispatch, paramss]);

  const handleApplyFilter = () => {
    const filters = {
      ...params,
      user_id: selectedData?.id || "", // Use selectedData's ID
    };
    setParams(filters);
    setModal(false);
  };
  const handleClearFilters = () => {
    setParams({
      page: 1,
      type: 1,
      search_key: "",
      status: "",
      service_type: "",
      startdate: "",
      enddate: "",
      user_id: "",
    });
    setModal(false);
  };
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term.trim() === "") {
      setFilteredData([]);
      setSelectedData(null);
    } else {
      const results = users?.users.filter(
        (item) =>
          item.full_name.toLowerCase().includes(term) ||
          String(item.mobile_number).includes(term)
      );
      setFilteredData(results);
    }
  };

  const handleSelect = (item) => {
    if (!item) return;
    setSelectedData(item);
    setSearchTerm(`${item.full_name}, ${item.mobile_number}`);
    setFilteredData([]);
    setParams((prevParams) => ({
      ...prevParams,
      user_id: item.id,
    }));
  };

  return (
    <>
      <Modal
        className="filter-modal"
        isOpen={modal}
        toggle={() => setModal((state) => !state)}
        centered
      >
        <ModalHeader toggle={() => setModal((state) => !state)}>
          Filter Options
        </ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Service-Type</label>
              <select
                className="form-control"
                name="service_type"
                value={params.service_type}
                onChange={handleInputChange}
              >
                <option value="">Select Service</option>
                <option value="1">Venue</option>
                <option value="2">Home</option>
              </select>
            </div>
            {params.type == 1 && (
              <div className="col-md-6 form-group">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={params.status}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  <option value="100">Waiting for Confirmation</option>
                  <option value="101">Confirmed</option>
                  {/* <option value="102">In-progress</option> */}
                </select>
              </div>
            )}

            {params.type == 2 && (
              <div className="col-md-6 form-group">
                <label>Status</label>
                <select
                  className="form-control"
                  name="status"
                  value={params.status}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  <option value="103">Completed</option>
                  <option value="104">Rejected</option>
                  <option value="105">Cancelled</option>
                </select>
              </div>
            )}
            <div className="col-md-6 form-group">
              <label>From-Date</label>
              <input
                type="date"
                className="form-control w-100"
                name="startdate"
                value={params.startdate}
                onChange={handleInputChange}
                // min={params.startdate && params.enddate && params.startdate <= params.enddate ? params.startdate : ''}
                // min={params.enddate ? params.startdate : ""}
              />
            </div>

            <div className="col-md-6 form-group">
              <label>End-Date</label>
              <input
                type="date"
                className="form-control w-100"
                name="enddate"
                value={params.enddate}
                onChange={handleInputChange}
                // min={params.startdate ? params.enddate : ""}
              />
            </div>
          </div>

          <div className="col-md-10 form-group">
            <label>Select Customer</label>
            <input
              type="search"
              id="user_id"
              placeholder="Search Customer"
              value={searchTerm}
              name="user_id"
              onChange={handleSearch}
              style={{
                width: "100%",
                padding: "10px 12px",
                fontSize: "16px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                outline: "none",
                transition: "border-color 0.3s, box-shadow 0.3s",
              }}
              className="custom-search-input"
            />

            <div
              className=""
              style={{
                padding: "0 15px",
                position: "absolute",
                left: "0",
                width: "100%",
              }}
            >
              {filteredData.length > 0 ? (
                <ul
                  style={{
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    background: "white",

                    zIndex: 1000,
                    maxHeight: "150px",

                    position: "relative",
                    overflowY: "auto",
                  }}
                >
                  {filteredData.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => handleSelect(item)}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      {item.full_name} {item?.country_code} {item.mobile_number}
                    </li>
                  ))}
                </ul>
              ) : searchTerm.trim() !== "" ? (
                <div className="dataShow"></div>
              ) : null}
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="justify-content-center">
          <button
            className="buttons border-button"
            onClick={handleClearFilters}
          >
            <span>Clear Filters</span>
          </button>
          <button
            className="buttons background-button"
            onClick={handleApplyFilter}
          >
            <span>Apply Filter</span>
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}
